/**
 * Panneau de filtres de collection + filtrage AJAX.
 *
 * Le filtrage passe par la Section Rendering API plutôt que par une
 * navigation complète : en production, un clic de filtre coûtait ~1,45 Mo
 * et ~1,6 s de TTFB (URL filtrée = cache miss CDN systématique), contre
 * ~75 Ko pour le rendu de la seule section.
 *
 * Le rechargement remplace toute la section, donc il détruit le <dialog>
 * ouvert : l'état (ouvert, scroll interne, groupes dépliés) est capturé
 * avant le remplacement puis restauré après.
 *
 * Toute erreur retombe sur une navigation classique.
 */
(function () {
  'use strict';

  var LOADING_CLASS = 'mm-filters-loading';
  var busy = false;

  /**
   * La barre de filtres colle sous l'en-tete du theme, lui-meme sticky et de
   * hauteur variable (la barre d'annonce disparait au scroll). On mesure donc
   * le bas des en-tetes colles et on l'expose en variable CSS.
   */
  function updateStickyOffset() {
    var offset = 0;
    var nodes = document.querySelectorAll('body [id^="shopify-section-"], body > header');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.querySelector('.mm-collection-container')) continue;
      var position = getComputedStyle(el).position;
      if (position !== 'sticky' && position !== 'fixed') continue;
      var rect = el.getBoundingClientRect();
      if (rect.height && rect.top <= 1 && rect.bottom > offset) offset = rect.bottom;
    }
    document.documentElement.style.setProperty('--mm-filters-top', Math.round(Math.max(offset, 0)) + 'px');
  }

  var offsetQueued = false;
  function queueStickyOffset() {
    if (offsetQueued) return;
    offsetQueued = true;
    window.requestAnimationFrame(function () {
      offsetQueued = false;
      updateStickyOffset();
    });
  }

  window.addEventListener('scroll', queueStickyOffset, { passive: true });
  window.addEventListener('resize', queueStickyOffset);
  document.addEventListener('DOMContentLoaded', updateStickyOffset);
  updateStickyOffset();

  function sectionEl() {
    var container = document.querySelector('.mm-collection-container');
    return container ? container.closest('[id^="shopify-section-"]') : null;
  }

  function dialogEl() {
    return document.querySelector('[data-mm-filters-dialog]');
  }

  function openDialog() {
    var dialog = dialogEl();
    if (!dialog || dialog.open) return;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDialog() {
    var dialog = dialogEl();
    if (dialog && dialog.open) dialog.close();
  }

  /** État à préserver au travers du remplacement de la section. */
  function captureState() {
    var dialog = dialogEl();
    var body = document.querySelector('[data-mm-filters-body]');
    var collapsed = [];
    document.querySelectorAll('[data-mm-filter]').forEach(function (group) {
      if (!group.open) collapsed.push(group.getAttribute('data-mm-filter'));
    });
    return {
      open: !!(dialog && dialog.open),
      scrollTop: body ? body.scrollTop : 0,
      collapsed: collapsed
    };
  }

  function restoreState(state) {
    if (!state.open) return;
    openDialog();
    // Un groupe que l'utilisateur avait replié le reste, même si le serveur
    // le renvoie ouvert parce qu'une de ses valeurs est active.
    state.collapsed.forEach(function (name) {
      var group = document.querySelector('[data-mm-filter="' + name + '"]');
      if (group) group.open = false;
    });
    var body = document.querySelector('[data-mm-filters-body]');
    if (body) body.scrollTop = state.scrollTop;
  }

  function render(url, pushToHistory) {
    var current = sectionEl();
    if (!current || busy) return;

    busy = true;
    var state = captureState();
    current.classList.add(LOADING_CLASS);

    var sectionId = current.id.replace('shopify-section-', '');
    var fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);

    fetch(fetchUrl.pathname + fetchUrl.search)
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[id^="shopify-section-"]');
        if (!fresh) throw new Error('section absente de la réponse');

        current.replaceWith(fresh);
        if (pushToHistory) window.history.pushState({ mmFilters: true }, '', url);

        restoreState(state);

        // Hook déjà attendu par <g-infinite-scroll> dans jc-bundle-collection.js :
        // il purge son cache de pages et repart de la nouvelle pagination.
        document.dispatchEvent(new CustomEvent('facet_updated'));
        busy = false;
      })
      .catch(function () {
        busy = false;
        window.location.href = url;
      });
  }

  document.addEventListener('click', function (event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('[data-mm-filters-open]')) {
      event.preventDefault();
      openDialog();
      return;
    }

    if (target.closest('[data-mm-filters-close]')) {
      event.preventDefault();
      closeDialog();
      return;
    }

    // Clic sur le fond assombri : la cible est le <dialog> lui-même.
    var dialog = dialogEl();
    if (dialog && target === dialog) {
      closeDialog();
      return;
    }

    // Un clic hors du menu de tri le referme.
    var openSort = document.querySelector('[data-mm-sort][open]');
    if (openSort && !target.closest('[data-mm-sort]')) openSort.open = false;

    var link = target.closest('.mm-filter-value, .mm-chip, .mm-filters-bar__clear, .mm-sort__option');
    if (!link) return;

    var url = link.getAttribute('href');
    if (!url) return;

    event.preventDefault();
    render(url, true);
  });

  // Échap et fermeture programmatique passent tous deux par l'événement close.
  document.addEventListener('close', function (event) {
    if (event.target && event.target.hasAttribute('data-mm-filters-dialog')) {
      document.documentElement.style.overflow = '';
    }
  }, true);

  // Bornes de prix : on applique a la validation du champ, pas a chaque frappe.
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.closest || !input.matches('[data-mm-price]')) return;

    var group = input.closest('[data-mm-price-group]');
    if (!group) return;

    var url = new URL(window.location.href);
    group.querySelectorAll('[data-mm-price]').forEach(function (field) {
      if (field.value === '' || Number(field.value) <= 0) url.searchParams.delete(field.name);
      else url.searchParams.set(field.name, field.value);
    });
    url.searchParams.delete('page');
    render(url.pathname + url.search, true);
  });

  window.addEventListener('popstate', function () {
    render(window.location.pathname + window.location.search, false);
  });
})();
